import React from 'react';
import { useAppSelector } from 'app/store';
import { getSong } from 'app/store/SongList/selectors';
import { Song } from 'types/song';
import { CollaboratorsList } from './CollaboratorsList';

export const Collaborators = () => {
  const song = useAppSelector(getSong) as Song;

  return <CollaboratorsList collaborators={song.collaborators} song={song} />;
};
